import { render } from "./BFormDatepickerCompat.vue?vue&type=template&id=5692d37f"
import script from "./BFormDatepickerCompat.vue?vue&type=script&lang=js"
export * from "./BFormDatepickerCompat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__